document.addEventListener('DOMContentLoaded', function () {
	// This is for all the buttons that open and close the categories and subcategories on mobile
	let categoriesNav = document.querySelector('.categories-nav');
	if (categoriesNav) {
		let openCategories = categoriesNav.querySelector('[data-trigger="open-cat-nav-mobile"]');
		openCategories?.addEventListener('click', function () {
			openCategories.classList.toggle('open');
		});
		let mainCategories = categoriesNav.querySelectorAll('li.main-category');
		mainCategories.forEach((category) => {
			let openTrigger = category.querySelector('[data-trigger="open-subcat-nav-mobile"]');
			let closeTrigger = category.querySelector('[data-trigger="close-subcat-nav-mobile"]');

			openTrigger.addEventListener('click', function () {
				category.classList.add('open-submenu');
			});
			closeTrigger.addEventListener('click', function () {
				category.classList.remove('open-submenu');
			});
		});

		// This is to measure the height the menu dropdown(s) should be on mobile
		// The goal is to have each dropdown fill to the bottom of the screen
		let header = document.querySelector('header.site-header');
		let topOffset = (header ? header.clientHeight : 0) + categoriesNav.clientHeight;
		let availableHeight = window.innerHeight - topOffset;
		categoriesNav.style.setProperty('--fill-height', availableHeight + 'px');

		window.addEventListener('resize', function () {
			topOffset = (header ? header.clientHeight : 0) + categoriesNav.clientHeight;
			availableHeight = window.innerHeight - topOffset;
			categoriesNav.style.setProperty('--fill-height', availableHeight + 'px');
		})
	}
})
